module.exports = __webpack_public_path__ + "img/new2-2.5ec27b09.png";